<img [src]="visible && value && value.srcData ? value.srcData : './assets/images/videoadd.png'" [alt]="alt"  [height]="height" [width]="width"> 
